export default "__VITE_ASSET__Pff3MdpI__"